// This is the entry point for the application (insofar as the
// React/Webpack pipeline is concerned). There are other scripts in the
// default Rails pipeline in /app/assets/javascripts (legacy code as of the
// introduction of React) that are loaded in before this application. This file
// bootstraps React, exposes NPM modules to the window object for legacy code,
// and runs other bootstrap scripts.

// Include Action Cable
require('../channels/index');

// Include Service Worker setup
require('./serviceworker-companion');

// Support component names relative to the ../components directory.
// React components are added to Rails views like so:
//  <%= react_component 'layout/foo/bar' %>
// which loads the component at /app/javascript/components/layout/foo/bar.jsx
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext);

// expose NPM modules for legacy code and too cool for school code
// eslint-disable-next-line import/no-extraneous-dependencies
const objectAssign = require('object.assign');

Object.assign = Object.assign || objectAssign.getPolyfill();

// eslint-disable-next-line import/no-extraneous-dependencies
const jQuery = require('jquery');

window.jQuery = jQuery;
window.$ = jQuery;
window.postal = require('postal');
require('@nishanths/zoom.js/dist/zoom.min.js');

// configure toastr
window.toastr = require('toastr');

window.toastr.options.positionClass = 'toast-bottom-full-width';

// Include other stuff that just needs to be included
require('../shared/bootstrap-carousels');
require('./vendor/browser-select-custom');

// run other bootstrap scripts
require('../bootstrap/bootstrap-accordions').default();
require('../bootstrap/bootstrap-profile').default();
require('../bootstrap/bootstrap-line-limiting').default();
require('../bootstrap/bootstrap-editors-picks-navbar').default();
require('../bootstrap/bootstrap-buttons').default();
require('../bootstrap/bootstrap-columnar').default();
require('../bootstrap/bootstrap-statistics').default();
require('../bootstrap/bootstrap-soundcloud-embeds').default();
require('../bootstrap/bootstrap-podbean-embeds').default();
require('../bootstrap/bootstrap-tabs').default();
require('../bootstrap/bootstrap-media-restricted-by-digital-pass').default();

require('trix');
require('@rails/actiontext');
